import { IMutationQuery, IQuery, IUserConfig, IAccountDetail } from '@/types';
import { decodeAuthToken } from '@/utils';
import ssoAxiosInstance from '@/utils/axios/ssoAxiosInstance';

export const authenticateMeQuery = (): IQuery<IUserConfig | null> => {
  const { organisationId, memberId } = decodeAuthToken() ?? {};
  return {
    queryKey: ['persist', 'me', organisationId, memberId],
    queryFn: async () => {
      // if (!organisationId || !memberId) {
      //   return null;
      // }
      const meDetails =
        await ssoAxiosInstance.get<IUserConfig>(`/authentication/me`);
      return meDetails.data;
    },
  };
};
